import React, { FC, forwardRef } from 'react';
import { SvgIconProps } from '@material-ui/core';
import { ReactComponent as FooterLogoSvg } from './footerLogoSvg.svg';
import { ReactComponent as LocationIconSvg } from './locationIconSvg.svg';
import { ReactComponent as PhoneIconSvg } from './phoneIconSvg.svg';
import { ReactComponent as LinkedinIconSvg } from './linkedinIconSvg.svg';
import { ReactComponent as FacebookIconSvg } from './facebookIconSvg.svg';
import { ReactComponent as ArrowIconSvg } from './arrowIconSvg.svg';
import { ReactComponent as TermsOfUseSvg } from './termsOfUse.svg';
import { ReactComponent as PrivacyPolicySvg } from './privacyPolicy.svg';

export const FooterLogo= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <FooterLogoSvg ref={ref} {...props} />);
export const LocationIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <LocationIconSvg ref={ref} {...props} />);
export const PhoneIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <PhoneIconSvg ref={ref} {...props} />);
export const LinkedinIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <LinkedinIconSvg ref={ref} {...props} />);
export const FacebookIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <FacebookIconSvg ref={ref} {...props} />);
export const ArrowIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <ArrowIconSvg ref={ref} {...props} />);
export const TermsOfUse= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <TermsOfUseSvg ref={ref} {...props} />);
export const PrivacyPolicy= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <PrivacyPolicySvg ref={ref} {...props} />);
